var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxPostBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    id: "Inbox-Post--Streamline-Sharp.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Inbox Post Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inbox-post--mail-flag-new-open-inbox-mailbox-post"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 853",
    fill: "#000000",
    d: "M3 9a4 4 0 0 1 4 -4h14v11H3V9Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#121212",
    fillRule: "evenodd",
    d: "M16 1h-3v2h2v7h2V1h-1Zm-5 15v7h2v-7h-2Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxPostBlack);
export default __webpack_public_path__ + "static/media/inbox-post-black.da151fdcc3187f332e7f4b8fc60653ce.svg";
export { ForwardRef as ReactComponent };